module.exports = __webpack_public_path__ + "static/media/PortadaRiesgos.4ab8e04f.png";